import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    createCostCodeRequest: ['payload', 'data'],
    createCostCodeSuccess: ['payload'],
    createCostCodeFailure: null,
    openCostCodeDrawer: ['payload'],
    closeCostCodeDrawer: null,
    updateFormField: ['payload'],
    resetFormFields: null,

    getCostCodesRequest: ['params'],
    getCostCodesSuccess: ['payload'],
    getCostCodesFailure: null,

    editCostCode: ['payload'],
    updateCostCodeRequest: ['params', 'payload'],
    updateCostCodeSuccess: ['payload'],
    updateCostCodeFailure: null,

    openConfirmationModal: ['payload'],
    closeConfirmationModal: null,
    deleteCostCodeRequest: ['params'],
    deleteCostCodeSuccess: ['payload'],
    deleteCostCodeFailure: null,

    updateSearchText: ['payload'],

    updatePageNumber: ['payload'],
    updatePerPage: ['payload'],

    openNoteModal: ['payload'],
    closeNoteModal: null,
    updateNoteMessage: ['payload'],
    createNoteRequest: ['payload'],
    createNoteSuccess: ['payload'],
    createNoteFailure: ['payload'],
    editNote: ['payload'],
    updateNoteRequest: ['params', 'payload'],
    updateNoteSuccess: ['payload'],
    updateNoteFailure: null,
    deleteNoteRequest: ['params'],
    deleteNoteSuccess: ['payload'],
    deleteNoteFailure: null,

    updateSortFields: ['payload'],
    updateSubCategoryOptions: ['payload'],
  },
  { prefix: 'COST_CODE/' },
);

export default Creators;
